class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NetworkError';
  }
}

export class HttpClient {
  static async fetch(url: string, options?: RequestInit): Promise<Response> {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new NetworkError(`HTTP error! Status: ${response.status}`);
    }

    return response;
  }

  static async get(url: string, options?: RequestInit): Promise<Response> {
    return HttpClient.fetch(url, { ...options, method: 'GET' });
  }

  static async post(url: string, body: unknown, options?: RequestInit): Promise<Response> {
    return HttpClient.fetch(url, { ...options, method: 'POST', body: JSON.stringify(body) });
  }
}
